export default __webpack_public_path__ + "static/media/clio-rs-gallery-5.c9bc8ac8.jpg";